import React, { useMemo } from 'react'
import { Typography, MediaImageStandard } from 'components/Contentful'
import { Box, Grid } from '@achieve/ascend'
import styles from './MediaBox.module.scss'
import { BLOCKS } from '@contentful/rich-text-types'
import { TitleDivider } from 'components/TitleDivider'
import SlideOnVisible from 'components/SlideOnVisible'
import {
  SLIDE_ON_VISIBLE_EASING_DEFAULT,
  SLIDE_ON_VISIBLE_DURATION_DEFAULT,
} from 'constants/animation'
import classNames from 'classnames'
import { withUuid } from 'utils/shared'

export const MediaBox = ({ title, subtitle, titles, subtitles, disclaimers, images, alts }) => {
  const titlesList = useMemo(() => withUuid(titles), [titles])

  const hasContent = () => {
    if (
      !Array.isArray(titles) ||
      !Array.isArray(images) ||
      titles.length < 3 ||
      images.length < 3
    ) {
      return false
    }
    return true
  }
  const mediaBoxSection = (
    <>
      <Grid container justifyContent="center" spacing={{ xs: 1, sx: 0, sm: 2, md: 4, lg: 6 }}>
        <Grid
          size={{ xxs: 10, xs: 11, md: 8, lg: 6 }}
          className="basis-10/12  sm:basis-8/12  md:basis-8/12 lg:basis-1/2"
          justifyContent="space-around"
          data-testid="mediabox-title"
        >
          <div className={styles['text-heading-container']}>
            <TitleDivider
              title={title}
              subtitle={subtitle}
              classNameTitleText="displayLg font-bold!"
              classNameSubtitleText="bodySm lg:displaySm font-light!"
            />
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="space-evenly"
        data-testid="media-box-image-item-0"
      >
        {titlesList.map((text, index) => {
          const image = images[index]
          const alt = alts[index]
          const subTitle = subtitles[index]
          const disclaimer = disclaimers[index]
          return (
            <React.Fragment key={text.uuid}>
              <Grid
                size={{ xxs: 12, md: 6 }}
                className="md:basis-1/2"
                sx={{ order: { xs: index + 1, md: index % 2 ? index + 2 : index + 1 } }}
              >
                <div className={styles['block-img']}>
                  <MediaImageStandard
                    content={image}
                    alt={alt}
                    layout="fill"
                    objectFit="cover"
                    preload={false}
                  />
                </div>
              </Grid>
              <Grid
                size={{ xxs: 12, md: 6 }}
                sx={{ order: { xs: index + 2, md: index % 2 ? index : index + 1 } }}
                className={classNames(styles['blue-box'], 'md:basis-1/2')}
                data-testid={`media-box-text-item-${index}`}
              >
                <Box className={styles['box-media-text']}>
                  <SlideOnVisible
                    scrollOnMobile={false}
                    duration={SLIDE_ON_VISIBLE_DURATION_DEFAULT}
                    timeout={0}
                    easing={SLIDE_ON_VISIBLE_EASING_DEFAULT}
                  >
                    <div>
                      <div className={styles['text-center']} data-testid="media-box-info-container">
                        <Typography
                          content={text}
                          className="displayLg lg:displayXl"
                          data-testid="media-box-title"
                        />
                        <Typography
                          content={subTitle}
                          className="bodySm lg:bodyLg"
                          data-testid="media-box-subtitle"
                        />
                        {disclaimer && (
                          <Typography
                            content={disclaimer}
                            variantOverride={{ [BLOCKS.PARAGRAPH]: 'bodyXs' }}
                            className={styles['disclaimer']}
                            fontWeight="light"
                            data-testid="media-box-disclaimer"
                          />
                        )}
                      </div>
                    </div>
                  </SlideOnVisible>
                </Box>
              </Grid>
            </React.Fragment>
          )
        })}
      </Grid>
    </>
  )

  return hasContent() ? mediaBoxSection : <></>
}
